import { useRef, useState } from "react";
import HeaderItem from "src/components/field/fields/Editor/HeaderItem";
import { uploadFile } from "src/lib/uploadFile";

interface ImageHeadItemProps {
	editor: any;
}

const ImageHeadItem = ({ editor }: ImageHeadItemProps) => {
	const input = useRef<HTMLInputElement>(null);
	const [loading, setLoading] = useState(false);

	const onChange = async (e: any) => {
		if (!e?.target?.files?.length) {
			setLoading(false);
			return;
		}
		const fd = new FormData();
		fd.append("file", e.target.files[0]);
		const { data: media } = await uploadFile("/media", fd).then(
			({ data }) => data
		);
		if (media.url) {
			editor.commands.setImage({
				src: media.url,
			});
		}
		setLoading(false);
	};

	return (
		<>
			<input
				className="hidden absolute"
				accept=".png, .jpg, .jpeg"
				ref={input}
				type="file"
				name="file"
				value=""
				{...{ onChange }}
				tabIndex={-1}
				onBlur={() => setLoading(false)}
			/>
			<HeaderItem
				{...{ loading }}
				disabled={!input?.current}
				onChange={() => {
					if (!input.current) return;
					setLoading(true);
					input.current.click();
				}}
				icon="fas fa-image"
			/>
		</>
	);
};

export default ImageHeadItem;
